import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Dialog from '~/components/Dialog'
import notify from '~/components/Notify'
import { handleErrors } from '~/utils/helpers'
import { CoolFarmService } from '~/api/services/coolFarm'

interface Props {
  deleteData: any
  handleClose: (submit?: boolean) => void
}

const DeleteModal: React.FC<Props> = (props) => {
  const { deleteData, handleClose } = props
  const { t } = useTranslation()

  const [isBusy, setIsBusy] = useState(false)

  async function handleDelete() {
    setIsBusy(true)
    try {
      await CoolFarmService.deleteCoolFarm(deleteData?.id)
      notify(t('Successfully deleted Cool Farm'), 'success')
      handleClose(true)
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  return <Dialog
    isDialogOpen={Boolean(deleteData)}
    handleClose={() => handleClose()}
    textHeader={t('Delete survey')}
    textContent={t('Do you really want to delete survey {{title}}?', { title: deleteData?.title })}
    textSubmit={t('Delete')}
    isLoading={isBusy}
    textClose={t('Close')}
    type={'abort'}
    handleSubmit={() => handleDelete()}
  />
}
export default DeleteModal